//Generated File 
export default class ChatMessageStatus{
	static readonly Delivered = `Delivered`;
	static readonly Failed = `Failed`;
	static readonly Pending = `Pending`;
	static readonly Read = `Read`;
	static readonly Sent = `Sent`;
}
